<docs>
  Backend requires value to be positive integer.
</docs>

<template>
  <div class="sub-form-integer sub-columns">
    <BaseInput name="min value" :validate="minValidator" class="sub-col" v-model="form.min" label="Min value"/>
    <BaseInput name="max value" validate="required|integer" class="sub-col" v-model="form.max" label="Max value" hint="0 = no max value"/>
    <BaseInput class="sub-col" :theme="!form.prefix ? 'grayed' : null" v-model="form.prefix" label="Prefix" hint="Shown while adding data"/>
    <BaseInput class="sub-col" :theme="!form.suffix ? 'grayed' : null" v-model="form.suffix" label="Suffix" hint="Shown while adding data"/>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          min: '0',
          max: '200',
          prefix: '',
          suffix: ''
        }
      }
    },
    computed: {
      minValidator () {
        return `required|integer|min_value:0${this.form.max == 0 ? '' : '|max_value:' + this.form.max }`
      }
    }
  }
</script>

<style lang="scss">

  .sub-form-integer {
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormInteger.vue